var map = {
	"./briefcase.svg": 8392,
	"./chevron-left.svg": 847,
	"./chevron-right.svg": 9520,
	"./france.svg": 3992,
	"./germany.svg": 1205,
	"./globe.svg": 9799,
	"./imagelink-icon.svg": 4075,
	"./japan.svg": 8290,
	"./quote.svg": 4651,
	"./spain.svg": 8976,
	"./united-kingdom.svg": 2064
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9556;